import { render, staticRenderFns } from "./CardShippingFeeFormPage.vue?vue&type=template&id=4e712089&scoped=true&"
import script from "./CardShippingFeeFormPage.vue?vue&type=script&lang=js&"
export * from "./CardShippingFeeFormPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e712089",
  null
  
)

export default component.exports